import { QueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'

const isAxiosErrorResponse = (error: any): error is AxiosError => error.isAxiosError

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: (failureCount, error: any) => {
        // If this is an axios error, we can know the response status code; keep retrying if unexpected server error
        // in hopes server will return to life.
        if (isAxiosErrorResponse(error)) {
          // Never retry on expected status codes.
          if ([400, 401, 403].includes(error.response?.status ?? 0)) {
            return false
          } else {
            return true
          }
        }
        // Keep default behavior otherwise, retry 3 times before accepting defeat.
        return failureCount <= 3
      },
    },
  },
})

export default queryClient
